// src/component/Pages/Profile.jsx

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProfileImg from "../../asserts/Component 278 – 1.png";
import { Button, Typography, Card, Box, Modal, Avatar, CircularProgress } from "@mui/material";
import Footer from "../footer";
import CircleBar from "../Common/circleBar";
import Dialog from "../ui/Dialog";
import { PrimaryButton, SecondaryButton } from "../ui/Buttons";
import Editprofile from "./Editprofile";
import { axiosInstance } from "../Api/instance";
import { showSuccess, showError } from "../../utils/popup";
import { auth } from "../../FirebaseConfig";
import { useNavigate } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import SchoolIcon from "@mui/icons-material/School";
import WcIcon from "@mui/icons-material/Wc";
import EditIcon from "@mui/icons-material/Edit";
import { styled } from "@mui/material/styles";

const ProfilePageContainer = styled(Box)(({ theme }) => ({
  minHeight: "85vh",
  backgroundColor: theme.palette.background.default,
  padding: "32px 0 0 0",
}));

const HeaderBanner = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1E3A8A 0%, #0D1B2A 100%)',
  borderRadius: "24px",
  padding: "48px 32px",
  position: "relative",
  color: "#FFFFFF",
  marginBottom: "32px",
  boxShadow: "0 10px 30px rgba(13, 27, 42, 0.15)",
}));

const ActionOverlay = styled(Box)({
  position: "absolute",
  top: "24px",
  right: "24px",
  display: "flex",
  gap: "12px",
});

const ProfileAvatarWrapper = styled(Box)({
  position: "relative",
  width: "140px",
  height: "140px",
  margin: "0 auto 20px auto",
  cursor: "pointer",
  "&:hover .avatar-edit-overlay": {
    opacity: 1,
  },
});

const EditOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  backgroundColor: "rgba(15, 23, 42, 0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#FFFFFF",
  opacity: 0,
  transition: "opacity 0.2s ease",
}));

const DetailsGrid = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "24px",
  marginTop: "16px",
}));

const DetailChip = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  backgroundColor: "rgba(255, 255, 255, 0.08)",
  padding: "8px 16px",
  borderRadius: "20px",
  fontSize: "0.875rem",
  border: "1px solid rgba(255, 255, 255, 0.1)",
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 800,
  fontSize: "1.25rem",
  marginBottom: "24px",
  color: theme.palette.text.primary,
}));

const ActivityCard = styled(Card)(({ theme }) => ({
  borderRadius: "20px",
  padding: "24px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  textAlign: "center",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "var(--color-shadow-hover)",
  },
}));

const NonNursingCard = styled(Card)(({ theme }) => ({
  borderRadius: "20px",
  padding: "24px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  height: "100%",
  display: "flex",
  alignItems: "center",
  gap: "24px",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "var(--color-shadow-hover)",
  },
}));

const DeleteAccountCard = styled(Card)(({ theme }) => ({
  borderRadius: "20px",
  padding: "28px 32px",
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(239, 68, 68, 0.05)' : '#FEF2F2',
  border: '1px solid rgba(239, 68, 68, 0.25)',
  boxShadow: "none",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "24px",
  [theme.breakpoints.down('sm')]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export default function Profile() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [del, setDel] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [subjectData, setsubjectdata] = useState([]);
  const [nonnursingData, setnonnursingdata] = useState([]);
  const email = localStorage.getItem("userMail") || localStorage.getItem("email");
  const profile = localStorage.getItem("profile");
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    subject();
    nonnursing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ViewProfile.php`, {
        email: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
          return;
        }
        setData(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const subject = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ScoreProfile_SW.php`, {
        userId: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
          return;
        }
        setsubjectdata(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error("Error fetching subject scores:", error);
    }
  };

  const nonnursing = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ScoreProfile_NN.php`, {
        userId: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
          return;
        }
        setnonnursingdata(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error("Error fetching non-nursing scores:", error);
    }
  };

  const handleDeleteAccount = async () => {
    if (isDeleting) return; // Prevent duplicate rapid requests
    setIsDeleting(true);

    try {
      const response = await axiosInstance.post("delete/U_deleteUser.php", {
        email: email,
        reason: "User requested account deletion via web",
      });

      if (response && (response.status === 200 || response.data?.success)) {
        setDel(false);
        // Clear local authentication/session storage
        localStorage.clear();
        sessionStorage.clear();

        // Sign out Firebase if Firebase authentication is currently used
        if (auth && typeof auth.signOut === "function") {
          try {
            await auth.signOut();
          } catch (e) {
            console.warn("Firebase signout error:", e);
          }
        }

        // Show professional success message
        await showSuccess(
          "Your account has been successfully deleted.",
          "Account Deleted Successfully"
        );

        // Redirect to /signin
        navigate("/signin", { replace: true });
      } else {
        throw new Error(response?.data?.message || "Unable to delete account");
      }
    } catch (error) {
      console.error("Error deleting user account:", error);
      showError(
        "We couldn't delete your account right now. Please try again later.",
        "Unable to Delete Account"
      );
    } finally {
      setIsDeleting(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    auth.signOut();
    setOpen(false);
    navigate("/signin");
  };

  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleClosed = () => setOpens(false);

  return (
    <ProfilePageContainer>
      {Array.isArray(data) && data.length > 0 ? (
        data.map((val) => (
          <Box key={val.email}>
            
            {/* LOGOUT CONFIRMATION DIALOG */}
            <Dialog 
              open={open} 
              onClose={() => setOpen(false)}
              title="Logout Session"
            >
              <Typography variant="body1" color="textSecondary" style={{ marginBottom: "24px" }}>
                Are you sure you want to end your study session and logout from the Nursing Update platform?
              </Typography>
              <Box style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                <SecondaryButton onClick={() => setOpen(false)}>
                  Cancel
                </SecondaryButton>
                <PrimaryButton 
                  onClick={handleLogout}
                  style={{ backgroundColor: "var(--color-danger)" }}
                >
                  Logout
                </PrimaryButton>
              </Box>
            </Dialog>

            {/* DELETE ACCOUNT CONFIRMATION DIALOG */}
            <Dialog 
              open={del} 
              onClose={() => !isDeleting && setDel(false)}
              title="Delete Account?"
            >
              <Typography variant="body1" color="textSecondary" style={{ marginBottom: "24px", lineHeight: 1.6 }}>
                Are you sure you want to delete your account? This action will remove your active account and sign you out of the application.
              </Typography>
              <Box style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                <SecondaryButton 
                  onClick={() => setDel(false)}
                  disabled={isDeleting}
                >
                  Cancel
                </SecondaryButton>
                <Button 
                  variant="contained"
                  onClick={handleDeleteAccount}
                  disabled={isDeleting}
                  style={{ 
                    backgroundColor: isDeleting ? "#94A3B8" : "var(--color-danger, #EF4444)",
                    color: "#FFFFFF",
                    borderRadius: "12px",
                    padding: "8px 24px",
                    fontWeight: 700,
                    textTransform: "none",
                    minWidth: "140px",
                  }}
                >
                  {isDeleting ? (
                    <CircularProgress size={20} style={{ color: "#FFFFFF" }} />
                  ) : (
                    "Delete Account"
                  )}
                </Button>
              </Box>
            </Dialog>

            <Container>
              {/* HEADER BANNER */}
              <HeaderBanner>
                <ActionOverlay>
                  <Button 
                    onClick={() => setOpen(true)}
                    variant="contained"
                    startIcon={<LogoutIcon />}
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      backdropFilter: "blur(4px)",
                      color: "#FFFFFF",
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                    }}
                  >
                    Logout
                  </Button>
                  <Button 
                    onClick={() => setDel(true)}
                    variant="contained"
                    style={{
                      backgroundColor: "rgba(239, 68, 68, 0.2)",
                      backdropFilter: "blur(4px)",
                      color: "#EF4444",
                      borderRadius: "12px",
                      minWidth: "42px",
                      padding: "8px",
                      border: "1px solid rgba(239, 68, 68, 0.3)",
                    }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </Button>
                </ActionOverlay>

                {/* Profile Photo */}
                <ProfileAvatarWrapper onClick={handleOpens}>
                  <Avatar
                    src={profile ? profile : ProfileImg}
                    alt={val.username}
                    style={{ width: "100%", height: "100%", border: "4px solid rgba(255, 255, 255, 0.2)" }}
                  />
                  <EditOverlay className="avatar-edit-overlay">
                    <EditIcon fontSize="medium" />
                  </EditOverlay>
                </ProfileAvatarWrapper>

                <Typography variant="h1" style={{ textAlign: "center", fontWeight: 800, letterSpacing: "-0.01em" }}>
                  {val.username}
                </Typography>

                {/* Details chips */}
                <DetailsGrid>
                  <DetailChip>
                    <MailOutlineIcon fontSize="inherit" />
                    {val.email}
                  </DetailChip>
                  <DetailChip>
                    <PhoneAndroidIcon fontSize="inherit" />
                    {val.mobileno}
                  </DetailChip>
                  {val.qualification && (
                    <DetailChip>
                      <SchoolIcon fontSize="inherit" />
                      {val.qualification}
                    </DetailChip>
                  )}
                  {val.gender && (
                    <DetailChip>
                      <WcIcon fontSize="inherit" />
                      {val.gender}
                    </DetailChip>
                  )}
                </DetailsGrid>
              </HeaderBanner>

              {/* MODAL EDIT PROFILE */}
              <Modal
                keepMounted
                open={opens}
                onClose={handleClosed}
                aria-labelledby="edit-profile-modal"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <Box style={{ outline: 'none', maxWidth: '600px', width: '90%' }}>
                  <Editprofile />
                </Box>
              </Modal>

              {/* MY ACTIVITY SECTION */}
              <Box style={{ marginBottom: "56px" }}>
                <SectionTitle>Nursing Subjects Performance</SectionTitle>
                <Row className="g-4">
                  {subjectData.map((e) => {
                    const accuracy = e.total_attended_count > 0
                      ? ((e.total_correct_count / e.total_attended_count) * 100).toFixed(1)
                      : 0;

                    return (
                      <Col key={e.category_id} xs={12} sm={6} md={4} lg={3}>
                        <ActivityCard>
                          <Typography variant="subtitle2" style={{ fontWeight: 800, marginBottom: "16px" }}>
                            {e.subject_name}
                          </Typography>
                          
                          <Box style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "20px" }}>
                            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                              <Typography variant="caption" color="textSecondary">Attended</Typography>
                              <Typography variant="caption" style={{ fontWeight: 700 }}>
                                {e.total_attended_count} / {e.total_questions_count}
                              </Typography>
                            </Box>
                            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                              <Typography variant="caption" color="textSecondary">Correct</Typography>
                              <Typography variant="caption" style={{ fontWeight: 700, color: "var(--color-success)" }}>
                                {e.total_correct_count}
                              </Typography>
                            </Box>
                            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                              <Typography variant="caption" color="textSecondary">Incorrect</Typography>
                              <Typography variant="caption" style={{ fontWeight: 700, color: "var(--color-danger)" }}>
                                {e.total_incorrect_count}
                              </Typography>
                            </Box>
                          </Box>

                          <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "12px", borderTop: "1px solid var(--color-border)", paddingTop: "12px" }}>
                            <Typography variant="caption" style={{ fontWeight: 700 }}>Accuracy</Typography>
                            <CircleBar range={parseFloat(accuracy)} />
                          </Box>
                        </ActivityCard>
                      </Col>
                    );
                  })}
                </Row>
              </Box>

              {/* NON-NURSING SECTION */}
              {nonnursingData.length > 0 && (
                <Box style={{ marginBottom: "56px" }}>
                  <SectionTitle>Non-Nursing & Aptitude Performance</SectionTitle>
                  <Row className="g-4">
                    {nonnursingData.map((r) => {
                      const accuracy = r.total_attended_count > 0
                        ? ((r.total_correct_count / r.total_attended_count) * 100).toFixed(1)
                        : 0;

                      return (
                        <Col key={r.category_id} xs={12} md={6}>
                          <NonNursingCard>
                            <Box style={{ flex: 1 }}>
                              <Typography variant="subtitle2" style={{ fontWeight: 800, marginBottom: "12px" }}>
                                {r.subject_name}
                              </Typography>
                              
                              <Box style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                                <Typography variant="caption" color="textSecondary">Attended: <strong>{r.total_attended_count}</strong></Typography>
                                <Typography variant="caption" color="textSecondary">Questions: <strong>{r.total_questions_count}</strong></Typography>
                                <Typography variant="caption" style={{ color: "var(--color-success)" }}>Correct: <strong>{r.total_correct_count}</strong></Typography>
                                <Typography variant="caption" style={{ color: "var(--color-danger)" }}>Incorrect: <strong>{r.total_incorrect_count}</strong></Typography>
                              </Box>
                            </Box>
                            
                            <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                              <Typography variant="caption" style={{ fontWeight: 700 }}>Accuracy</Typography>
                              <CircleBar range={parseFloat(accuracy)} />
                            </Box>
                          </NonNursingCard>
                        </Col>
                      );
                    })}
                  </Row>
                </Box>
              )}

              {/* DELETE ACCOUNT SECTION */}
              <Box style={{ marginBottom: "56px" }}>
                <SectionTitle style={{ color: "var(--color-danger, #EF4444)" }}>
                  Delete Account
                </SectionTitle>
                <DeleteAccountCard>
                  <Box style={{ flex: 1 }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: "8px" }}>
                      Delete Account
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ maxWidth: "720px", lineHeight: 1.6 }}>
                      Deleting your account will permanently remove your active student account from the application.
                    </Typography>
                  </Box>
                  <Button
                    variant="outlined"
                    onClick={() => setDel(true)}
                    disabled={isDeleting}
                    style={{
                      borderColor: "var(--color-danger, #EF4444)",
                      color: "var(--color-danger, #EF4444)",
                      borderRadius: "12px",
                      padding: "10px 24px",
                      fontWeight: 700,
                      textTransform: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Delete My Account
                  </Button>
                </DeleteAccountCard>
              </Box>

            </Container>
            <Footer />
          </Box>
        ))
      ) : (
        <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
          <Typography variant="body1" color="textSecondary">
            Loading profile information...
          </Typography>
        </Box>
      )}
    </ProfilePageContainer>
  );
}
